import React from 'react'
import './index.less'
import classNames from 'classnames'
import { Property } from 'csstype'

type FlexProps = {
    style?: React.CSSProperties
    className?: string
    children?: React.ReactNode
    gap?: number
    justify?: Property.JustifyContent
    align?: Property.AlignItems
    vertical?: boolean
}

const Flex: React.FC<FlexProps> = (props) => {

    const { style, className, children, gap = 10, justify, align, vertical = false } = props

    return (
        <div
            style={{
                justifyContent: justify,
                alignItems: align,
                gap,
                flexDirection: vertical ? 'column' : 'row',
                ...style
            }}
            className={classNames(['os-flex', className])}>
            {children}
        </div>
    )
}

export default Flex